import actionTypes from './actionTypes';

// TODO: Is newQuantity actually needed line 19?

export default {
  [actionTypes.CARTITEMS_REMOVE_START]: itemId => ({
    type: actionTypes.CARTITEMS_REMOVE_START,
    itemId,
  }),
  [actionTypes.CARTITEMS_REMOVE_SUCCESS]: itemId => ({
    type: actionTypes.CARTITEMS_REMOVE_SUCCESS,
    itemId,
  }),
  [actionTypes.CARTITEMS_REMOVE_FAIL]: (itemId, error) => ({
    type: actionTypes.CARTITEMS_REMOVE_FAIL,
    itemId,
    error,
  }),
  [actionTypes.CARTITEMGROUP_REMOVE_START]: itemIds => ({
    type: actionTypes.CARTITEMGROUP_REMOVE_START,
    itemIds,
  }),
  [actionTypes.CARTITEMGROUP_REMOVE_SUCCESS]: (itemIds, groupId) => ({
    type: actionTypes.CARTITEMGROUP_REMOVE_SUCCESS,
    itemIds,
    groupId,
  }),
  [actionTypes.CARTITEMGROUP_REMOVE_FAIL]: (itemIds, error) => ({
    type: actionTypes.CARTITEMGROUP_REMOVE_FAIL,
    itemIds,
    error,
  }),
  [actionTypes.CARTITEMS_QUANTITY_UPDATE_START]: (itemId, newQuantity) => ({
    type: actionTypes.CARTITEMS_QUANTITY_UPDATE_START,
    itemId,
    newQuantity,
  }),
  [actionTypes.CARTITEMS_QUANTITY_UPDATE_SUCCESS]: itemId => ({
    type: actionTypes.CARTITEMS_QUANTITY_UPDATE_SUCCESS,
    itemId,
  }),
  [actionTypes.CARTITEMS_QUANTITY_UPDATE_FAIL]: (
    itemId,
    originalQuantity,
    error
  ) => ({
    type: actionTypes.CARTITEMS_QUANTITY_UPDATE_FAIL,
    itemId,
    originalQuantity,
    error,
  }),
};
